import constantType from './constantType'

//CONSTANT
export const successFetchedConstant =(data)=>({
type: constantType.SUCCESS_FETCHIED_CONSTANT,
payload: data
 })
export const failureFetchedConstant =(data)=>({
type: constantType.FAILURE_FETCHED_CONSTANT,
payload: data
 })

 //change search params
 export const changePageParams =(data)=>({
    type: constantType.CHANGE_GRADE_PARAMS,
    errorMessage: data
     })

